"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCollectionDetails = exports.collectionDetails = exports.getCollectionDetailsSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getCollectionDetailsSerializer() {
    return (0, serializers_1.dataEnum)([
        [
            'V1',
            (0, serializers_1.struct)([
                ['size', (0, serializers_1.u64)()],
            ]),
        ],
        [
            'V2',
            (0, serializers_1.struct)([
                ['padding', (0, serializers_1.array)((0, serializers_1.u8)(), { size: 8 })],
            ]),
        ],
    ], { description: 'CollectionDetails' });
}
exports.getCollectionDetailsSerializer = getCollectionDetailsSerializer;
function collectionDetails(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.collectionDetails = collectionDetails;
function isCollectionDetails(kind, value) {
    return value.__kind === kind;
}
exports.isCollectionDetails = isCollectionDetails;
//# sourceMappingURL=collectionDetails.js.map